import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FullScreenModal } from "../../../../Constant";
import { FULLSCREEN_MODAL_DATA } from "../../../../Data/UiKit/Modal";
import FullModal from "./FullModal";
import FullScreenBelowSm from "./FullScreenBelowSm"
import FullScreenBelowMd from "./FullScreenBelowMd"
import FullScreenBelowLg from "./FullScreenBelowLg"
import FullScreenBelowXl from "./FullScreenBelowXl"
import FullScreenBelowXxl from "./FullScreenBelowXxl"

const FullScreenModals = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={FullScreenModal} span={FULLSCREEN_MODAL_DATA} />
        <div className="card-body badge-spacing">
          <FullModal />
          <FullScreenBelowSm />
          <FullScreenBelowMd />
          <FullScreenBelowLg />
          <FullScreenBelowXl />
          <FullScreenBelowXxl />
        </div>
      </Card>
    </Col>
  );
};

export default FullScreenModals;